/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/260-point-up': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15 9.5V7a1.502 1.502 0 00-2.236-1.307 1.5 1.5 0 00-2.264-.31A1.494 1.494 0 009 5.086V1.5C9 .673 8.327 0 7.5 0S6 .673 6 1.5v6.167L3.25 6.201a1.502 1.502 0 00-1.789 2.381l.012.011L5.21 12H4.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h10a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-.691l1.138-2.276A.496.496 0 0015 9.5zm-1 4a.5.5 0 11-1 0 .5.5 0 011 0zm0-4.118L12.691 12H6.694L2.15 7.857a.5.5 0 01.614-.782l3.5 1.866a.499.499 0 00.735-.441v-7a.5.5 0 011 0v5a.5.5 0 001 0 .5.5 0 011 0 .5.5 0 001 0 .5.5 0 011 0V7a.5.5 0 001 0 .5.5 0 011 0v2.382z"/>'
  }
})
